export default class PaginatedResultSet<T> {
  count: number;

  values: T[];
}
